import { useRef, useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import './App.css'

mapboxgl.accessToken = 'pk.eyJ1IjoibWljcm9tYWNoaW5lIiwiYSI6ImNsa2t5OHB2ZzE4aWozZ3J6cm5ud3I5cTIifQ.RkdaJppiR-xJ1zDUYuoUDw'

function App() {
  const mapRef = useRef(null)
  const mapContainerRef = useRef(null)
  const userMarkerRef = useRef(null)
  const watchIdRef = useRef(null)
  const [path, setPath] = useState([]) // tableau de positions

  useEffect(() => {
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/light-v11',
      center: [4.5910, 50.7030],
      zoom: 15,
    })

    mapRef.current.addControl(new mapboxgl.NavigationControl(), 'top-left')

    mapRef.current.on('load', () => {
      mapRef.current.resize()

      // Ajouter le relief 3D (DEM)
      mapRef.current.addSource('mapbox-dem', {
        type: 'raster-dem',
        url: 'mapbox://mapbox.terrain-rgb',
        tileSize: 512,
        maxzoom: 14,
      });
      mapRef.current.setTerrain({ source: 'mapbox-dem', exaggeration: 1.5 });

      mapRef.current.addSource('custom-image', {
      type: 'image',
      url: 'https://web-treeosk.online/mapbox/walibi.webp', // Remplace par l'URL de ton image
        coordinates: [
          [4.5910, 50.7030], // coin supérieur gauche [lng, lat]
          [4.5960, 50.7030], // coin supérieur droit
          [4.5960, 50.7000], // coin inférieur droit
          [4.5910, 50.7000], // coin inférieur gauche
        ]
      });

      mapRef.current.addLayer({
        id: 'custom-image-layer',
        type: 'raster',
        source: 'custom-image',
        paint: {
          'raster-opacity': 1
        }
      });
    })

    if (navigator.geolocation) {
      watchIdRef.current = navigator.geolocation.watchPosition(
        position => {
          const { longitude, latitude } = position.coords
          console.log('Position reçue :', longitude, latitude)

          // Mise à jour du marker personnalisé
          if (!userMarkerRef.current) {
            const el = document.createElement('div')
            el.className = 'custom-user-location'

            userMarkerRef.current = new mapboxgl.Marker({ element: el })
              .setLngLat([longitude, latitude])
              .addTo(mapRef.current)
          } else {
            userMarkerRef.current.setLngLat([longitude, latitude])
          }

          // Ajouter la nouvelle position au tableau path
          setPath(prevPath => {
            const newPath = [...prevPath, [longitude, latitude]]

            // Mettre à jour la source GeoJSON de la ligne sur la carte
            if (mapRef.current.getSource('path')) {
              mapRef.current.getSource('path').setData({
                type: 'Feature',
                geometry: {
                  type: 'LineString',
                  coordinates: newPath,
                },
              })
            }
            return newPath
          })

          // Centrer la carte sur la position
          mapRef.current.setCenter([longitude, latitude])
        },
        error => {
          console.error('Erreur de géolocalisation :', error)
        },
        {
          enableHighAccuracy: true,
          maximumAge: 1000,
          timeout: 10000,
        }
      )
    } else {
      console.error('Géolocalisation non supportée')
    }

    return () => {
      if (mapRef.current) mapRef.current.remove()
      if (watchIdRef.current) navigator.geolocation.clearWatch(watchIdRef.current)
    }
  }, [])

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }} />
    </div>
  )
}

export default App
